import { defineComponent } from 'vue'

export default defineComponent({
  name: 'DeleteIconBtn',
  setup() {
    return {}
  },
})
